import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { companiesApi } from "./api";
import { Button, Card, PageTitle } from "../../components/ui";
import { QueryView } from "../../components/states";
import { AllCompaniesMap } from "../../components/map/CompanyMap";

// 全体地図（F-18）。座標を登録した公開企業を地図上にピン表示する。
export function PublicMapPage() {
  const query = useQuery({
    queryKey: ["companies", "public", "map"],
    queryFn: () => companiesApi.mapPins(),
  });

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <PageTitle title="受入企業マップ" subtitle="地図から受入企業をさがせます。" />
        <div className="flex gap-2">
          <Link to="/map/search">
            <Button variant="ghost">地図から範囲検索</Button>
          </Link>
          <Link to="/">
            <Button variant="ghost">一覧にもどる</Button>
          </Link>
        </div>
      </div>
      <QueryView
        query={query}
        emptyWhen={(d) => d.items.length === 0}
        emptyMessage="地図に表示できる企業がまだありません（所在地が登録されると表示されます）。"
      >
        {(data) => (
          <Card className="space-y-2">
            <AllCompaniesMap pins={data.items} />
            <p className="text-center text-xs text-slate-400">
              地図に表示: {data.items.length} 件
              {data.capped && `（上限 ${data.cap} 件まで。絞り込んで検索してください）`}
            </p>
          </Card>
        )}
      </QueryView>
    </div>
  );
}
